import { css } from 'linaria';
import { styled } from 'linaria/react';

export const StyledLi = styled.li`
	list-style: none;
`;
export const FilterListCheckboxStyle = css`
	align-items: flex-start;
`;
